import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Fotter from "../components/Fotter";
import { BASE_URL } from "./Config";
import axios from "axios";
import { Link } from "react-router-dom";
import Form from "./Form";

export default function CustomerCare() {
  const [CustomerCare, setCustomerCare] = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/get_CustomerCare.php?t=${Date.now()}`)
      .then((res) => {

       // console.log(res)
        if (res.data.success) {
          setCustomerCare(res.data.data);
          console.log(res.data.data);
        } else {
          console.error("API response error:", res.data.message);
        }
      })
      .catch((err) => console.error("API request failed:", err));
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${BASE_URL}/enquiry_submit.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response from server:", response.data);
      console.log("Form data sent:", formData);

      if (response.data.success) {
        setSubmitted(true);
        setFormData({
          name: "",
          phone: "",
          email: "",
          message: "",
        });
      } else {
        console.error("Server error:", response.data.message);
      }
    } catch (error) {
      console.error("Submission error:", error);
    }
  };

  useEffect(() => {
    if (submitted) {
      const timer = setTimeout(() => setSubmitted(false), 5000);
      return () => clearTimeout(timer);
    }
  }, [submitted]);
  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME</p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span> /</span>
                <p>Customer Care</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div
            className="row"
            dangerouslySetInnerHTML={{
              __html: String(CustomerCare.content),
            }}
          ></div>
        </div>
      </div>

      <Form />

      <Fotter />
    </>
  );
}
